/**
 * Reads master usage alt without falling back to asset.altText.
 */
export default function resolveMasterUsageAltText(asset, { productId, variantId, isVariant }) {
  if (isVariant && variantId) {
    const link = (asset?.productVariants || []).find(
      (entry) => String(entry.variantId) === String(variantId) && entry.type === 'masterVariant',
    );
    if (!link || typeof link.altText !== 'string') return '';
    return link.altText;
  }

  const link = (asset?.products || []).find(
    (entry) => String(entry._id) === String(productId) && entry.type === 'master',
  );
  if (!link || typeof link.altText !== 'string') return '';
  return link.altText;
}
